// extracted by mini-css-extract-plugin
module.exports = {"btnIcon":"Button_btnIcon__2O50S","btnText":"Button_btnText__TKEU9"};